import { FC } from 'react'
import { Box, IconButton, ToggleButtonGroup, ToggleButton, Tooltip, useTheme } from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import AddIcon from '@mui/icons-material/Add'
import TextSnippetIcon from '@mui/icons-material/TextSnippet'
import SummarizeIcon from '@mui/icons-material/Summarize'

import styles from './styles.module.scss'
import { IPlaybook } from '../../../../types/playbook.type'
import { useNavigate } from 'react-router'
import { SidebarMode } from '../Sidebar'

interface IProps {
  playbook: IPlaybook | undefined
  sidebarMode: SidebarMode | null
  onSidebarModeChange: (sidebar: SidebarMode) => void
}

const Header: FC<IProps> = ({ playbook, sidebarMode, onSidebarModeChange }) => {
  const theme = useTheme()
  const navigate = useNavigate()

  return (
    <Box
      className={styles.playbookHeader}
      sx={{
        background: theme.palette.elevated.main,
        borderBottom: '1px solid ' + theme.palette.elevated.light,
      }}
    >
      <Box className={styles.playbookTitle}>
        <Tooltip title="Back to the playbook list" disableInteractive>
          <IconButton size="small" className={styles.backButton} onClick={() => navigate('/playbooks')}>
            <ArrowBackIcon />
          </IconButton>
        </Tooltip>
        <Box className={styles.playbookTitleText}>{playbook?.name}</Box>
      </Box>
      <ToggleButtonGroup value={sidebarMode} exclusive onChange={(_, val) => onSidebarModeChange(val)}>
        <ToggleButton value={SidebarMode.Add}>
          <AddIcon sx={{ mr: 0.8 }} />
          Add nodes
        </ToggleButton>
        <ToggleButton value={SidebarMode.EventLog}>
          <TextSnippetIcon sx={{ mr: 1 }} />
          Event log
        </ToggleButton>
        <ToggleButton value={SidebarMode.Reports}>
          <SummarizeIcon sx={{ mr: 1 }} />
          Reports
        </ToggleButton>
      </ToggleButtonGroup>
    </Box>
  )
}

export default Header
